import { render, staticRenderFns } from "./inventoryrecord.vue?vue&type=template&id=cd91c54a&scoped=true"
import script from "./inventoryrecord.vue?vue&type=script&lang=ts"
export * from "./inventoryrecord.vue?vue&type=script&lang=ts"
import style0 from "./inventoryrecord.vue?vue&type=style&index=0&id=cd91c54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd91c54a",
  null
  
)

export default component.exports